// frontend/src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/home";
import Products from "./components/products";
import Contact from "./components/contact";
import Blog from "./components/blog";




function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} /> {/* Home page */}
        <Route path="/products" element={<Products />} /> {/* Products page */}
        <Route path="/contact" element={<Contact />} /> {/* Contact page */}
        <Route path="/blog/:id?" element={<Blog />} /> {/* Blog page */}
      </Routes>
    </Router>
  );
}

export default App;
